export default __webpack_public_path__ + "static/media/img_gas_phase_01.a3de8064.png";